import * as THREE from 'three';

/**
 * スキャン元アプリによって上下・向き・スケールが異なるため、物件データ側で補正する。
 * スプラットでもメッシュでも同じ規則で適用する。
 */
export function applyTransform(object, transform) {
  const { rotationX, rotationY, rotationZ, scale, position } = transform;
  object.rotation.set(
    THREE.MathUtils.degToRad(rotationX),
    THREE.MathUtils.degToRad(rotationY),
    THREE.MathUtils.degToRad(rotationZ),
  );
  object.scale.setScalar(scale);
  object.position.fromArray(position);
  object.updateMatrixWorld(true);
}
